import { render, staticRenderFns } from "./AttachmentBatches.vue?vue&type=template&id=0864e3c4"
import script from "./AttachmentBatches.vue?vue&type=script&lang=js"
export * from "./AttachmentBatches.vue?vue&type=script&lang=js"
import style0 from "./AttachmentBatches.vue?vue&type=style&index=0&id=0864e3c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports